import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Shipment report',
      title: 'Shipment report',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'Request successfully sent',
      filterErrorMessage: 'Select only one document',
    }
  }
}